import { sendRequest } from "./requests";
import { getCoursesFromDatabase } from "./requests_get_all";

// -- Luhn algorithm to validate EFN
const isValidLuhn = (number) => {
    const digits = number.split('').map(Number);
    let sum = 0;
    let isEven = false;

    for (let i = digits.length - 1; i >= 0; i--) {
        let digit = digits[i];

        if (isEven) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }

        sum += digit;
        isEven = !isEven;
    }

    return sum % 10 === 0;
};

// -- send ALL remaining teilnehmer (no EIV_Datum) from ALL courses to eiv
const sendAllToEiv = async (tokenObject, setTokenObject) => {
    // GET ALL COURSES FROM DATABASE
    const allCourses = await getCoursesFromDatabase(tokenObject, setTokenObject);

    // create one array with all courses to be sent to eiv
    const filteredCourses = allCourses.filter(course => course.id === "CME_Kurse" || course.id === "GCP" || course.id === "Live")
    var courses = [];
    for (let i = 0; i < filteredCourses.length; i++) {
        courses = courses.concat(filteredCourses[i].data)
    }

    // run through courses
    for (let i = 0; i < courses.length; i++) {
        const thisCourse = courses[i];
        const vnr = thisCourse.VNR;
        const kursKey = thisCourse.KursKey;

        // GET TEILNEHMER OF THIS COURSE
        const response = await sendRequest(tokenObject, setTokenObject, 'POST', '/kursteilnahme/kursTeilnehmer', `Lade Teilnehmer aus Kurs "${kursKey}"`, `Teilnehmer aus Kurs "${kursKey}" geladen`, { KursKey: kursKey });

        if (response.success) {
            const kursTeilnRelation = response.data;

            // use teilnehmer without eiv-date
            const teilnehmerWithoutEivDate = kursTeilnRelation.filter(elem => !elem.EIV_Datum);
            //console.log(`KursKey: "${kursKey}"\nVNR: "${vnr}"\nTeilnehmer ohne EIV_Datum: `, teilnehmerWithoutEivDate);
            // send this to eiv
            await sendToEiv(tokenObject, setTokenObject, vnr, kursKey, teilnehmerWithoutEivDate);
        }
    }
}

// -- send teilnehmer to EIV
const sendToEiv = async (tokenObject, setTokenObject, vnr, kursKey, allRelations, filter = true) => {
    //console.log("sendToEiv called with: ", { vnr, kursKey, allRelations, filter });
    try {
        // copy allRelations
        var allRelationsCopy = [...allRelations];
        //console.log("allRelationsCopy: ", allRelationsCopy);

        // filter=true -> use array of teilnehmer without eiv-date
        if (filter && allRelationsCopy) allRelationsCopy = allRelationsCopy.filter(teilnehmer => !teilnehmer.EIV_Datum);

        // only use teilnehmer with efn containing 80276 and length 15 AND valid luhn checksum
        const invalidLuhnEfns = [];
        if (allRelationsCopy) {
            allRelationsCopy = allRelationsCopy.filter(teilnehmer => {
                const efn = teilnehmer.EFN;
                const hasCorrectFormat = efn.includes('80276') && efn.length === 15;
                if (!hasCorrectFormat) return false;

                const luhnValid = isValidLuhn(efn);
                if (!luhnValid) {
                    invalidLuhnEfns.push(efn);
                    return false;
                }
                return true;
            });
        }

        // -- alert if invalid luhn EFNs found
        if (invalidLuhnEfns.length > 0) {
            alert(
                `Folgende EFNs sind nicht Luhn-valide und werden nicht gesendet:\n\n` +
                invalidLuhnEfns.map((efn, i) => `${i + 1}. ${efn}`).join('\n')
            );
        }

        if (allRelationsCopy && allRelationsCopy.length > 0 && vnr) {

            if (window.confirm(`KursKey: "${kursKey}"\n\nVNR: "${vnr}"\n${allRelationsCopy.length} Teilnehmer an EIV melden?`)) {

                // fill a cleaned-up teilnehmer-array otherwise payload large
                var cleanedTeilnehmerArray = [];
                for (let i = 0; i < allRelationsCopy.length; i++) {
                    const relation = allRelationsCopy[i];

                    const cleanedTeilnehmer = {
                        EFN: relation.EFN,
                        Teilnahmedatum: relation.Teilnahmedatum,
                        // set Lernkontrolle for each Teilnehmer (1 -> all answers are correct)
                        Lernkontrolle: (relation.AnswerKey === relation.CorrectAnswerKey) ? 1 : 0
                    }

                    cleanedTeilnehmerArray.push(cleanedTeilnehmer);
                }

                // request-body
                const body = {
                    "VNR": vnr,
                    "Meldungsart": "N",
                    "Teilnehmer": cleanedTeilnehmerArray
                }

                // -- send it
                console.log("send to eiv: ", cleanedTeilnehmerArray);

                // SEND TEILNEHMER TO EIV
                const response = await sendRequest(tokenObject, setTokenObject, 'POST', '/eiv/sendToEiv', `Sende an EIV`, `An EIV gesendet`, body);

                if (response.success) {
                    // open response in a window
                    var myWindow = window.open("", "EIV Response Fenster", "width=800,height=500");

                    const sentEfns = response?.data?.sent_efns || [];
                    const efnsHtml = sentEfns.length
                        ? `<ul>${sentEfns.map(efn => `<li>${efn}</li>`).join('')}</ul>`
                        : `<p>Keine EFNs vorhanden.</p>`;

                    const html = `
                        <html>
                            <head>
                                <title>EIV Versand</title>
                                <style>
                                    body { font-family: Arial, sans-serif; padding: 16px; }
                                    h2 { margin-top: 0; }
                                    .box { border: 1px solid #ddd; border-radius: 8px; padding: 12px; background: #f9f9f9; }
                                    ul { margin: 8px 0 0; padding-left: 18px; }
                                </style>
                            </head>
                            <body>
                                <h2>Versand an EIV erfolgreich</h2>
                                <div class="box">
                                    <p>${response.message || 'Erfolgreich gesendet.'}</p>
                                    <h4>Übermittelte EFNs</h4>
                                    ${efnsHtml}
                                </div>
                            </body>
                        </html>
                    `;

                    if (myWindow) {
                        myWindow.document.open();
                        myWindow.document.write(html);
                        myWindow.document.close();
                    }
                    return true;
                }
                else return false;
            }
        }
        else return false;
    }
    catch (e) {
        console.log(e);
        return false;
    }
}

export { sendAllToEiv, sendToEiv }